<template>
  <b-nav
    class="navbar-items"
    pills
  >
    <router-link
      v-for="route in routes"
      :key="route.path"
      v-slot="{ href }"
      custom
      :to="route"
    >
      <!-- Following href is trusted -->
      <b-nav-item
        :active="isActive(route)"
        active-class="active"
        class="header-nav-item"
        :data-testid="route.name"
        :href="href"
        @click.prevent="isDisabled(route) ? $emit('show-modal') : $emit('refresh', $event, route)"
      >
        <template v-if="route.meta.i18nTitle">{{ t(route.meta.i18nTitle) }} </template>
        <translate v-else>{{ route.meta.title }} </translate>
        <b-badge
          v-if="route.meta.nb_contribution && $store.getters.getNbContribution(route.meta.nb_contribution) !== null"
          class="badge-nb-items"
          variant="default"
        >
          {{ $store.getters.getNbContribution(route.meta.nb_contribution) }}
        </b-badge>
        <span
          v-else-if="route.meta.nb_contribution"
          class="text-center ml-1"
          style="flex: auto"
          ><i class="fa fa-circle-notch fa-spin"
        /></span>
      </b-nav-item>
    </router-link>
  </b-nav>
</template>

<script>
export default {
  name: 'MainHeaderSubMenu',
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  emits: ['refresh', 'show-modal'],
  methods: {
    isActive(route) {
      return this.$route.matched.some((r) => r.name === route.name)
    },
    isDisabled(route) {
      if (route.meta) {
        return !route.meta.is_authorized(route)
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-items {
  padding-left: 10px !important;
}

.header-nav-item > .nav-link {
  font-size: 15px !important;
  line-height: 22px !important;
  padding-right: 24px !important;
  padding-left: 24px !important;
  margin-right: 10px;
  color: #161616 !important;
}

@media screen and (min-width: 1283px) and (max-width: 1443px) {
  .header-nav-item > .nav-link {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}

@media screen and (min-width: 200px) and (max-width: 1282px) {
  .header-nav-item > .nav-link {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f4f6f9 !important;
  color: #161616 !important;
}

.header-nav-item > .nav-link:hover {
  font-weight: 400 !important;
  border-bottom: 3px #2c5263 solid !important;
  border-radius: 0px !important;
}

.header-nav-item > .nav-link.active {
  font-weight: 700 !important;
  border-bottom: 3px #2c5263 solid !important;
  border-radius: 0px !important;
}

.header-nav-item > .nav-link.disabled {
  font-weight: 400 !important;
  border-bottom: 3px #8d8d8d00 solid !important;
  border-radius: 0px !important;
  color: #c6c6c6 !important;
}

// TODO: Use a meta-variable for colors
.badge-nb-items {
  background-color: #b1b1b1;
  min-width: 18px;
  min-height: 18px;
  margin-left: 0.5em;
  color: white;
  font-weight: 700;
}
.nav-link.active .badge-nb-items {
  color: white;
  background-color: #0a4650;
}
</style>
